import { Alert, Button, Stack } from '@mui/material';
import { useRef, useEffect } from 'react';

import type { PermissionWarningProps } from './types';

export function PermissionWarning({ userName, onConfirm, onCancel, sx }: PermissionWarningProps) {
  const alertRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    alertRef.current?.focus();
  }, []);

  return (
    <Alert
      ref={alertRef}
      role="alertdialog"
      tabIndex={-1}
      severity="warning"
      variant="outlined"
      sx={[{ mt: 1 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      action={
        <Stack direction="row" spacing={1}>
          <Button size="small" color="inherit" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="small" color="warning" variant="contained" onClick={onConfirm}>
            Mention anyway
          </Button>
        </Stack>
      }
    >
      <strong>{userName}</strong> may not have access to this record.
    </Alert>
  );
}
